<template>
  <div class="navCenter">
    <div class="nav">
      <div
        :class="item.value == active ? 'active item' : 'item'"
        v-for="item in navList"
        :key="item.value"
        @click="tabClick(item)"
      >
        <span class="text">{{ item.label }}</span>
      </div>
      <div class="flex-yCenter flex-sb text" @click="logOut">
        <img src="@/assets/images/index/logOut.png" alt />
        <span class>退出登录</span>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
export default {
  data() {
    return {
      navList: [
        { label: "首页", value: 1, path: "/add/index" },
        { label: "进修记录", value: 2, path: "/record/index" },
        { label: "院内报到", value: 3, path: "/report/index" },
        // { label: "进修过程登记", value: 4, path: "/process/index" },
        { label: "进修考核", value: 5, path: "/examine/index" },
        { label: "离院登记", value: 6, path: "/leave/index" },
      ],
      active: 1,
    };
  },
  created() {
    this.active = this.$route.meta.type;
  },
  methods: {
    tabClick(e) {
      this.$router.push(e.path);
    },
    logOut() {
      this.$confirm("", "退出登录", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((e) => {
        store.dispatch("LogOut").then(() => {
          window.location.href = "#/login";
        });
      });
    },
  },
  watch: {
    $route(to, from) {
      this.active = to.meta.type;
    },
  },
};
</script>
<style lang="scss" scoped>
.navCenter {
  background-color: #253d88;
}

.nav {
  width: 1200px;
  height: 60px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.9);
  font-size: 20px;
}

.text {
  margin-left: auto;
  line-height: 60px;
  cursor: pointer;
  img {
    width: 25px;
  }
}

.item {
  padding: 0 20px;
  text-align: center;

  &:hover {
    color: white;
    cursor: pointer;
    background-color: #2d53c8;
  }
}

.active {
  background-color: #2d53c8;
  color: white;
}
</style>
